<script>
import get from 'lodash/get'
import sum from 'lodash/sum'
import { mapGetters } from 'vuex'
import MenuItem from '@/components/cars/edit/MenuItem.vue'

export default {
  components: {
    'mia-menu-item': MenuItem
  }
}
</script>

<template>
  <div>
    <mia-has-feature feature="lead_potentials">
      <mia-menu-item
        :to="{ name: 'leads.settings.potentials' }"
        icon="layout-module-1"
        without-progress
      >
        Potentiale
      </mia-menu-item>
    </mia-has-feature>
  </div>
</template>
